import { Button, Popover, Skeleton, Box, Typography } from '@mui/material';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isReadOnly } from '../../utils/permissionUtils';

const Header = (props) => {
  const { loader, title, isSelect, setIsSelect, setSelectPart } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [active, setActive] = useState('Mechanical Progress');
  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleItemClick = (data) => {
    setActive(data);
    if (data === "Logistics Management") {
      navigate("/dashboard/logistics-management");
    } else if (data === "Mechanical Progress") {
      navigate("/dashboard");
    }
    handleClose();
  };

  const open = Boolean(anchorEl);
  const id = open ? 'progress-popover' : undefined;

  const handleClickBlock = () => {
    setIsSelect(!isSelect)
    setSelectPart([])
  }

  return (
    <Box mb={2} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap"}}>
      <Box>
        {loader ? (
          <Skeleton variant="rectangular" width={280} height={30} />
        ) : (
           <Box>{title ? <Typography fontSize={22} fontWeight={600}>Construction - {title} Progress</Typography> : <Typography fontSize={22} fontWeight={600}>Construction Progress</Typography> } </Box>
        )}
      </Box>

      <Box sx={{ gap: 4, display: "flex", alignItems: "center" }}>
        <Button variant="contained" className="font-[600]" onClick={handleClickBlock}  disabled ={isReadOnly()}>
        {isSelect ? "Clear Blocks" : "Select Blocks"} 
        </Button>

        <Button
          variant="contained"
          aria-describedby={id}
          onClick={handleClick}
          className="font-[600]"
          endIcon={open ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
        >
             {active}
        </Button>

        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          PaperProps={{
            sx: {
                width: 230,
                height: 100,
                overflowY: 'hidden',
                overflowX: 'hidden',
            },
            }}
        >
          <Box sx={{ p: 1 }}>
            {["Mechanical Progress", "Logistics Management"].map(
              (item, index) => (
                <Box key={index}>
                  <Box
                    onClick={() => handleItemClick(item)}
                    sx={{
                      py: 0.5,
                      px: 2,
                      mb: 1,
                      borderRadius: 1,
                      fontWeight: 500,
                      color: active === item ? "#f16253" : "text.primary",
                      bgcolor: active === item ? "#fff2f1" : "transparent",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                      "&:hover": {
                        bgcolor: "#fff2f1",
                        color: "#f16253",
                      },
                    }}
                    role="menuitem"
                    aria-label={item}
                  >
                    {item}
                  </Box>
                </Box>
              )
            )}
          </Box>
        </Popover>
      </Box>
    </Box>
  );
};

export default Header;

